import styled from '@emotion/styled'

export const RootDiv = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`
